/**
 * A phone number as people read it: "(205) 987-5605". Ten digits, or eleven with a leading country
 * code 1, however they were punctuated; anything else is shown as it was typed, so nothing is lost.
 */
export function formatPhone(phone: string | null | undefined): string {
  const typed = phone?.trim() ?? '';
  const digits = typed.replace(/\D/g, '');
  const local = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (local.length !== 10) return typed;
  return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
}
